export const initalDiagram = '<?xml version="1.0" encoding="UTF-8"?>\n' +
  '<bpmn:definitions xmlns:bpmn="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:di="http://www.omg.org/spec/DD/20100524/DI" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:camunda="http://camunda.org/schema/1.0/bpmn" xmlns:pw="http://philips.com/schema/bpmn/pathways" id="Definitions_1lnnb79" targetNamespace="http://bpmn.io/schema/bpmn" exporter="Camunda Modeler" exporterVersion="1.14.0">\n' +
  '  <bpmn:process id="Process_1" isExecutable="true">\n' +
  '    <bpmn:startEvent id="StartEvent_0l44dxb">\n' +
  '      <bpmn:outgoing>SequenceFlow_1cv9mf0</bpmn:outgoing>\n' +
  '    </bpmn:startEvent>\n' +
  '    <bpmn:sequenceFlow id="SequenceFlow_1cv9mf0" sourceRef="StartEvent_0l44dxb" targetRef="head_node_id" />\n' +
  '    <bpmn:task id="head_node_id">\n' +
  '      <bpmn:incoming>SequenceFlow_1cv9mf0</bpmn:incoming>\n' +
  '      <bpmn:extensionElements>\n' +
  '        <pw:nodeDetails nodeType="2"/>\n' +
  '      </bpmn:extensionElements>\n' +
  '    </bpmn:task>\n' +
  '  </bpmn:process>\n' +
  '  <bpmndi:BPMNDiagram id="BPMNDiagram_1">\n' +
  '    <bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_1">\n' +
  '      <bpmndi:BPMNShape id="StartEvent_0l44dxb_di" bpmnElement="StartEvent_0l44dxb">\n' +
  '        <dc:Bounds x="166.390243902439" y="277.54355400696863" width="36" height="36" />\n' +
  '        <bpmndi:BPMNLabel>\n' +
  '          <dc:Bounds x="184.390243902439" y="317.54355400696863" width="0" height="12" />\n' +
  '        </bpmndi:BPMNLabel>\n' +
  '      </bpmndi:BPMNShape>\n' +
  '      <bpmndi:BPMNEdge id="SequenceFlow_1cv9mf0_di" bpmnElement="SequenceFlow_1cv9mf0">\n' +
  '        <di:waypoint x="202" y="296" />\n' +
  '        <di:waypoint x="252" y="296" />\n' +
  '        <bpmndi:BPMNLabel>\n' +
  '          <dc:Bounds x="227" y="275" width="0" height="12" />\n' +
  '        </bpmndi:BPMNLabel>\n' +
  '      </bpmndi:BPMNEdge>\n' +
  '      <bpmndi:BPMNShape id="SubProcess_1" bpmnElement="head_node_id" isExpanded="false">\n' +
  '        <dc:Bounds x="252" y="256" width="168" height="48" />\n' +
  '      </bpmndi:BPMNShape>\n' +
  '    </bpmndi:BPMNPlane>\n' +
  '  </bpmndi:BPMNDiagram>\n' +
  '</bpmn:definitions>\n';
